// GENERATED FILE, PLEASE DO NOT EDIT
var iconDefinitions = [{
  name: 'DealsFill',
  fileName: 'deals-fill',
  sizes: ['24']
}, {
  name: 'HomeFill',
  fileName: 'home-fill',
  sizes: ['24']
}, {
  name: 'HomeLine',
  fileName: 'home-line',
  sizes: ['24']
}, {
  name: 'MoneyCircleEnabledFill',
  fileName: 'money-circle-enabled-fill',
  sizes: ['24']
}, {
  name: 'MoneyCircleEnabledLine',
  fileName: 'money-circle-enabled-line',
  sizes: ['24']
}, {
  name: 'OrderBagFill',
  fileName: 'order-bag-fill',
  sizes: ['24']
}, {
  name: 'PersonProfileFill',
  fileName: 'person-profile-fill',
  sizes: ['24']
}, {
  name: 'PersonProfileLine',
  fileName: 'person-profile-line',
  sizes: ['24']
}, {
  name: 'ReceiptFill',
  fileName: 'receipt-fill',
  sizes: ['24']
}, {
  name: 'ReceiptLine',
  fileName: 'receipt-line',
  sizes: ['24']
}, {
  name: 'SearchFill',
  fileName: 'search-fill',
  sizes: ['24']
}, {
  name: 'SearchLine',
  fileName: 'search-line',
  sizes: ['24']
}, {
  name: 'VehicleBikeLine',
  fileName: 'vehicle-bike-line',
  sizes: ['24']
}];

export { iconDefinitions };
